module.exports = __webpack_public_path__ + "static/media/landgrn.52ae71b8.png";